var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneAndNumber = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3383_220)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.55 78.53c19.09 0 34.56-8.52 34.56-19.04 0-10.5-15.47-19.03-34.56-19.03C19.47 40.46 4 48.98 4 59.49c0 10.52 15.47 19.04 34.55 19.04Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.33 3.06 41.88.01s-.75-.63-1.9-.05C38.84.54 20.3 11.33 20.3 11.33s-3.53 1.52-3.53 5.16l.09 51.48s0 1.27 1 1.85c.94.55 4.58 1.95 5.42 2.1.67.12 1.43-.5 1.43-.5s-1.51.91-2.51-.08c-.52-.52-.38-1.84-.38-2.64V18.8s.06-3.25 2.95-4.6c2.89-1.34 20-11.17 20-11.17s.79-.47 1.56.03Z",
    fill: "white",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.83 70.3V19.02a5.38 5.38 0 0 1 2.76-4.7l20.19-11.3a1.52 1.52 0 0 1 2.26 1.34l-.23 51.86a3.93 3.93 0 0 1-1.95 3.37l-20.61 12.1a1.6 1.6 0 0 1-2.42-1.39Z",
    fill: "white",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.28 12.8 1.23.84c.54.36 1.22.4 1.77.08l8.18-4.62a2.46 2.46 0 0 0 1.2-1.7l.3-1.68-12.68 7.09Z",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.83 12.23-.08-.14a.24.24 0 0 1 .1-.32l6.52-3.56a.24.24 0 0 1 .33.1l.07.13c.07.12.03.26-.1.33l-6.52 3.56a.24.24 0 0 1-.32-.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.33 25.34V20.8c0-.45.37-.82.82-.82.44 0 .81.37.81.82v4.55c0 .45-.37.82-.81.82a.81.81 0 0 1-.82-.82Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.33 32.35v-4.56c0-.45.37-.82.82-.82.44 0 .81.37.81.82v4.56a.81.81 0 0 1-1.63 0Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 25.72a7.52 7.52 0 0 1 7.52-7.52h47.09a7.52 7.52 0 0 1 0 15.04H16.12a7.52 7.52 0 0 1-7.52-7.52Z",
    fill: "#0061AF",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 28.16v-5.09h.94v4.3h2.66v.79h-3.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6 28.16v-5.09h2.09c.45 0 .83.08 1.15.22.33.15.58.35.75.63.17.27.26.59.26.96 0 .38-.09.7-.26.97s-.42.48-.75.62c-.32.15-.7.22-1.15.22h-1.57l.42-.44v1.91h-.95Zm.94-1.8-.42-.47h1.52c.42 0 .73-.08.94-.26a.92.92 0 0 0 .32-.75c0-.32-.1-.57-.32-.75-.2-.17-.52-.26-.94-.26h-1.52l.42-.46v2.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.02 28.21a.59.59 0 0 1-.6-.6c0-.19.06-.33.18-.44a.59.59 0 0 1 .42-.17.59.59 0 0 1 .6.6.6.6 0 0 1-.18.44.59.59 0 0 1-.42.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.25 28.21a.59.59 0 0 1-.42-.17.6.6 0 0 1-.18-.43c0-.19.06-.33.18-.44a.59.59 0 0 1 .42-.17.59.59 0 0 1 .6.6.59.59 0 0 1-.6.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.47 28.21a.59.59 0 0 1-.42-.17.6.6 0 0 1-.17-.43c0-.19.06-.33.17-.44a.59.59 0 0 1 .42-.17.59.59 0 0 1 .6.6.59.59 0 0 1-.6.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.22 28.23c-.4 0-.76-.1-1.09-.3-.32-.2-.57-.5-.75-.89-.19-.4-.28-.87-.28-1.42 0-.56.1-1.03.28-1.42.18-.4.43-.7.75-.9.33-.2.7-.3 1.1-.3.4 0 .76.1 1.08.3.32.2.58.5.76.9.19.39.28.86.28 1.42 0 .55-.1 1.03-.28 1.42a1.99 1.99 0 0 1-1.85 1.2Zm0-.82c.24 0 .45-.06.62-.19.18-.13.31-.33.4-.6.11-.26.16-.6.16-1 0-.42-.05-.75-.15-1.01a1.2 1.2 0 0 0-.4-.6 1 1 0 0 0-.63-.19 1 1 0 0 0-.6.2c-.18.12-.32.32-.42.59-.1.26-.15.6-.15 1 0 .41.05.75.15 1.02.1.26.24.46.41.6.18.12.39.18.61.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.67 28.16 2.1-4.7.25.41h-2.89l.45-.46v1.33h-.87v-1.67h3.95v.64l-1.98 4.45h-1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.25 28.16 2.1-4.7.25.41H37.7l.45-.46v1.33h-.88v-1.67h3.96v.64l-1.98 4.45h-1.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.67 28.23c-.4 0-.77-.1-1.1-.3-.31-.2-.56-.5-.75-.89-.18-.4-.28-.87-.28-1.42 0-.56.1-1.03.28-1.42.19-.4.44-.7.76-.9.32-.2.68-.3 1.09-.3.4 0 .77.1 1.09.3.32.2.57.5.75.9.2.39.29.86.29 1.42 0 .55-.1 1.03-.29 1.42-.18.39-.43.68-.75.89-.32.2-.69.3-1.1.3Zm0-.82c.23 0 .44-.06.61-.19.18-.13.31-.33.41-.6.1-.26.15-.6.15-1 0-.42-.05-.75-.15-1.01a1.2 1.2 0 0 0-.4-.6 1 1 0 0 0-.62-.19 1 1 0 0 0-.61.2c-.18.12-.32.32-.42.59-.1.26-.14.6-.14 1 0 .41.05.75.14 1.02.1.26.24.46.42.6.18.12.38.18.6.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 28.16v-4.72l.4.42h-1.48v-.79h2.02v5.09h-.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15 28.23a3.7 3.7 0 0 1-1.06-.15c-.34-.1-.62-.25-.86-.44l.41-.73a2.46 2.46 0 0 0 1.49.5c.34 0 .6-.07.8-.2a.67.67 0 0 0 .28-.57.66.66 0 0 0-.26-.55c-.18-.14-.46-.2-.85-.2h-.46v-.65l1.45-1.73.12.35h-2.73v-.79h3.47v.64l-1.46 1.72-.49-.29h.28c.63 0 1.1.14 1.4.43.32.27.48.63.48 1.06 0 .29-.07.55-.22.8-.14.24-.37.43-.67.58-.3.15-.67.22-1.12.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.11 28.16-2.22-5.09h1.02l1.99 4.6h-.59l2-4.6h.95l-2.22 5.09h-.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.72 28.23a2.7 2.7 0 0 1-1.95-.73 2.55 2.55 0 0 1-.77-1.88c0-.38.07-.73.2-1.05a2.55 2.55 0 0 1 1.44-1.37c.33-.13.7-.2 1.09-.2.41 0 .8.07 1.14.22.34.14.63.35.87.63l-.61.57a1.8 1.8 0 0 0-1.36-.6 2 2 0 0 0-.73.14c-.22.09-.41.21-.58.37a1.76 1.76 0 0 0-.5 1.29c0 .26.04.5.12.72.1.21.22.4.38.56.17.16.36.29.57.37a2 2 0 0 0 1.48-.01c.23-.1.43-.26.62-.46l.6.58c-.23.28-.52.49-.86.63-.35.15-.73.22-1.15.22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3383_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneAndNumber);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone_and_number.cd4fc9cb6c8ad04bc0cffd7ffbd648e9.svg";